// AR / American Rag — digital showroom catalog.
// 100% sourced from AR_American_Rag_Complete_Style_References.pdf (see /app/memory/MASTER_CATALOG.md).
// Product images are the real photos cropped from the reference sheets (/refs/cad/<code>.jpg).
// Denim uses approved model photography generated from the real CADs + the real wash swatch strips.
// NO invented names, colors, washes, descriptions or graphics.
import { DENIM, HOME_HERO } from "./media";

const cad = (code, sfx = "") => `/refs/cad/${code}${sfx}.jpg`;
const id = (code, sfx = "") => (code + sfx).toLowerCase();

export const HERO = { home: HOME_HERO, homeAlt: DENIM.ar0008mst.model };

// -------------------------------------------------------------- Denim --------
export const WOMEN_WASHES = ["SV1001", "SV1002", "SV1003", "SV1004", "BLACK"];
export const MEN_WASHES = ["AR1", "AR2", "AR3", "AR4", "AR5", "AR6", "AR7"];
export const WASH_STRIP = { Women: "/refs/cad/washes_women.jpg", Men: "/refs/cad/washes_men.jpg" };

const DENIM_STYLES = [
  { code: "ARW0008ST", printed: "HIGH RISE STRAIGHT", gender: "Women", category: "women-denim", washes: WOMEN_WASHES },
  { code: "ARW000BT", printed: "MID-RISE BOOT CUT", gender: "Women", category: "women-denim", washes: WOMEN_WASHES },
  { code: "AR0008MSL", printed: "SLIM DENIM PANTS", gender: "Men", category: "men-denim", washes: MEN_WASHES },
  { code: "AR0008MST", printed: "STRAIGHT DENIM PANTS", gender: "Men", category: "men-denim", washes: MEN_WASHES },
];

const denimProducts = DENIM_STYLES.map((d) => ({
  id: id(d.code), styleCode: d.code, gender: d.gender, category: d.category,
  garmentType: "Jean", name: d.printed, treatment: null, graphic: null,
  washes: d.washes, washStrip: WASH_STRIP[d.gender],
  image: DENIM[id(d.code)].model, cadRef: DENIM[id(d.code)].ref,
  badge: `${d.washes.length} Washes`, sub: `${d.washes.length} washes`, hero: true,
}));

// --------------------------- Graphic styles (verbatim from the sheets) -------
// [code, treatment(verbatim), graphic(verbatim or null when stylized/garbled)]
const MEN_TEES = [
  ["AR6210MT", "Embroidery", "AMERICAN RAG"],
  ["AR6211MT", "Flock Print / Embroidery", "ALL RIGHTS RESERVED · AMERICAN RAG · SINCE 1984"],
  ["AR6212MT", "Foil Print / 3D Emboss", "AMERICAN RAG ORIGINAL"],
  ["AR6213MT", "Denim Applique", "AMERICAN RAG AR"],
  ["AR6214MT", "3D Emboss / Deboss", "AMERICAN RAG"],
  ["AR6215MT", "Puff Print", "AMERICAN RAG · New York · Studio"],
  ["AR6216MT", "PU Patch / Emb.", "AMERICAN RAG · WHITE LABEL"],
  ["AR6217MT", "Reflective Logo / Emb.", "AR · AMERICAN RAG"],
  ["AR6218MT", "Embroidery", "AMERICAN RAG"],
  ["AR6219MT", "Jacquard Woven Label", "AMERICAN RAG"],
  ["AR6220MT", "Puff Print", "URBAN ARTIFACTS · AMERICAN RAG 1984"],
  ["AR6221MT", "Woven Label / Print", "AMERICAN RAG · Finest Quality Goods · Est. NY 1984"],
  ["AR6222MT", "Woven Label / Print", "AMERICAN RAG"],
  ["AR6223MT", "Embroidery / Print", "AMERICAN RAG · ESSENTIAL UNCERTAINTY · PAUSE / REPLAY / ERASE"],
  ["AR6224MT", "Flock Print / Print", "American Rag Essentials · OFF-LINE PERSPECTIVE · NEW YORK · LOS ANGELES · EST. 1984"],
  ["AR6225MT", "Embroidery Applique / Print", null],
  ["AR6226MT", "Silicone Print / Print", null],
  ["AR6227MT", "Embroidery / Puff Print", "AMERICAN RAG 84"],
  ["AR6228MT", "Puff Print / Silicone Raised", "AMERICAN RAG est. 1984 · AR"],
];

const MEN_FLEECE = [
  ["AR1148MT", "Silicone Heat Seal", "AMERICAN.R ESSENTIALS"],
  ["AR1149MT", "Embroidery / Chenille Patch", "AMERICAN RAG · ATHLETIC CLUB · 84"],
  ["AR1150MT", "Denim Applique / Embroidery", "arag 84"],
  ["AR1151MT", "Flock Print", "AMER RAG"],
  ["AR1152MT", "Embroidery / Chenille Patch", "A.RAG · AMERICAN RAG · MCMLXXXIV"],
  ["AR1153MT", "Puff Print", "EST. 1984 · AMERICAN RAG · NEW YORK STATE"],
  ["AR1154MT", "Embroidery / Applique", "Designed in New York · AMERICAN.R ORIGINAL"],
  ["AR1155MT", "Applique w/ Embroidery", "A-RAG · Original Label"],
  ["AR1156MT", "Embroidery / Print", null],
  ["AR1157MT", "Applique / Embroidery", "AMER RAG"],
  ["AR1158MT", "Applique / Embroidery", "A.RAG"],
  ["AR1159MT", "Embroidery", "AMERAG · ORIGINAL EIGHTY FOUR"],
  ["AR1160MT", "Flock Print", "A-RAG-NY 1984 · NEW YORK STATE"],
  ["AR1161MT", "3D Emboss with Embroidery", "AMERICAN RAG · Designed in New York"],
  ["AR1162MT", "3D Raised Silicone", "AMERICAN RAG.NYC"],
  ["AR1163MT", "Chenille Embroidery", "AMER RAG · Original Label"],
  ["AR1164MT", "Embroidery", "AMERICAN RAG"],
  ["AR1165MT", "Emb. / Dome Stud", "AR · AMERICAN RAG"],
  ["AR1166MT", "Full Embroidery", "American 84"],
  ["AR1167MT", "Embroidery", "A.rag"],
  ["AR1168MT", "Flock Print", null],
  ["AR1169MT", "Jersey Applique", "AMER RAG"],
  ["AR1170MT", "Twill Applique", null],
  ["AR1171MT", "Chenille Patch / Spray Print", "AR"],
  ["AR1172MT", "Silicone Print", "AMERICAN RAG · NEW YORK"],
  ["AR1173MT", "Print / Puff Embroidery", "ALL RIGHTS RESERVED · AMERICAN RAG · SINCE 1984"],
  ["AR1174MT", "Embroidery", null],
  ["AR1175MT", "Embroidery / Print", "AMERICAN RAG · ATHLETIC DEPT · EST NEW YORK 1984 · WHITE LABEL"],
  ["AR1176MT", "Multi-Color Embroidery", "AMERICAN RAG"],
  ["AR1177MT", "Twill Applique", "AMERICAN RAG · MCMLXXXIV"],
  ["AR1178MT", "Emb. / PU Patch", null],
  ["AR1179MT", "3D Embroidery", "AMERICAN RAG"],
  ["AR1180MT", "Embroidery Applique / Print", "AMERICAN RAG · ORIGINAL"],
  ["AR1181MT", "Chenille Patch / Print", "AR · AMERICAN RAG · Since 1984"],
  ["AR1182MT", "Embroidery / Print", "AMERICAN RAG · MONOCHROME STATE OF MIND · DESIGN STUDIO"],
  ["AR1183MT", "Embroidery / Print", "American Rag · EST. 84 · Since 1984"],
  ["AR1184MT", "Embroidery Patch / Print", "American Rag · Original"],
  ["AR1185MT", "Embroidery / Print", "American Rag 84"],
  ["AR1186MT", "Embroidery / Print", "American Rag · EST. 84"],
  ["AR1187MT", "Embroidery Patch / Print", "American Rag · DEFINED BY NO ONE · SINCE NINETEEN EIGHTY FOUR"],
  ["AR1188MT", "Embroidery Patch / Print", null],
];

const WOMEN_TEES = [
  ["AR2158WT", "Glitter Print", "AMERICAN RAG"],
  ["AR2159W", "Hot Fix / Glitter Print", "PEACE · AMERICAN RAG"],
  ["AR2160W", "Glitter Print", "AR"],
  ["AR2161W", "Glitter Print / Hot Fix", "original label · A.rag"],
  ["AR2162WT", "Flock Print / Hot Fix", "AMER RAG"],
  ["AR2165WT", "3D Deboss + Emboss", "AMERICAN RAG"],
  ["AR2166W", "Glitter Print / Hot Fix", "AMERICAN RAG 84"],
  ["AR2168W", "Embroidery", "AMERICAN RAG"],
  ["AR2169WT", "Hot Fix / Deboss Logo", "AMERICAN RAG"],
  ["AR2170WT", "Ombre Print", null],
  ["AR2171WT", "Puff Embroidery / Beads", "AMERICAN RAG"],
  ["AR2172WT", "Animal Print Applique", "AMERICAN RAG"],
];

// Women fleece & hoodies — code=file. Pages 11-12.
const WOMEN_FLEECE_1 = [
  ["AR21660W", "Black Glitter / Rhinestone", null],
  ["AR21661W", "Puff Print / Rhinestone", "love · AMOUR · PEACE"],
  ["AR21662W", "Embroidery / Rhinestone", "A.rag"],
  ["AR21663W", "Glitter Print / Rhinestone", "A-RAG · AMOUR NEW YORK 84"],
  ["AR21667W", "Embroidery / Rhinestone", "SINCE 1984 · AMERICAN RAG"],
  ["AR21668W", "Sequins", "American Rag"],
  ["AR21669W", "Beaded Patch / Embroidery", "LOVE PARIS"],
];

// Women fleece & hoodies — page 14, code shares with tees, file suffix _F.
const WOMEN_FLEECE_2 = [
  ["AR2167WT", "Hot Fix", "American Rag · New York"],
  ["AR2168WT", "Chenille Embroidery / Flock Print", "AMER RAG"],
  ["AR2169WT", "Glitter Print / Hot Fix", "original label · A.rag"],
  ["AR2170WT", "Hot Fix / Glitter Print", "NEW YORK · ATELIER · AMERICAN RAG"],
  ["AR2171WT", "Print / Hot Fix", "N.Y.C"],
];

// Women fleece & hoodies — page 16, file suffix _F.
const WOMEN_FLEECE_3 = [
  ["AR2173WT", "Glitter Print / Silicone Print / Hot Fix", "American Rag · 1984"],
  ["AR2174WT", "Foil Print / Embroidery", "AMERICAN RAG · 1984"],
  ["AR2175WT", "Hot Fix / Gold 3D Raised Print", "AMERICAN RAG"],
  ["AR2176WT", "3D Silicone / Glitter", "AMERICAN RAG"],
  ["AR2177WT", "Bead Embroidery", "AR"],
  ["AR2178WT", "Stud Trim / Emb. Logo", "american rag"],
  ["AR2179WT", "Embroidery", "AMERICAN RAG · Originals"],
  ["AR2180WT", "Sequin Patch", "AMERICAN RAG"],
];

// New men's basic tees (latest reference PDF) — individual photos in /refs/new/.
const MEN_BASIC_TEES = [
  ["AR6204MT", "Embroidery Logo", "AMERICAN RAG"],
  ["AR6205MT", "Embroidery", "AR"],
  ["AR6206MT", "Rubber Patch", "American Rag"],
];

// New men's button-down denim shirts (latest reference PDF).
const MEN_SHIRTS = [
  { file: "shirt_grey", code: "GREY WASH", name: "Long Sleeve Denim Shirt", desc: "Grey Wash · AR pocket embroidery" },
  { file: "shirt_black", code: "BLACK WASH", name: "Long Sleeve Denim Shirt", desc: "Black Wash · AR pocket embroidery" },
  { file: "shirt_dark", code: "DARK WASH", name: "Long Sleeve Denim Shirt", desc: "Dark Wash · AR pocket embroidery" },
  { file: "shirt_medium", code: "MEDIUM WASH", name: "Long Sleeve Denim Shirt", desc: "Medium Wash · AR pocket embroidery" },
  { file: "shirt_short", code: "SHORT SLEEVE", name: "Short Sleeve Denim Shirt", desc: "Blue · button-down" },
];

// New women's t-shirt dresses (latest reference PDF) — individual photos in /refs/new/.
const WOMEN_DRESSES = [
  ["AR2172WD", "AMERICAN RAG — box logo"],
  ["AR2173WD", "AR — star embellishment"],
  ["AR2174WD", "AMERICAN RAG — Love"],
  ["AR2175WD", "american rag"],
  ["AR2176WD", "AR — leopard applique"],
  ["AR2177WD", "AR monogram — rhinestone"],
  ["AR2178WD", "AR monogram"],
  ["AR2179WD", "AMERICAN RAG EST. 84 — lace hem"],
  ["AR2180WD", "AMERICAN RAG"],
  ["AR2181WD", "AMERICAN RAG"],
  ["AR2182WD", "American Rag — script"],
];

const HERO_SET = new Set([
  "AR1149MT", "AR1153MT", "AR6215MT", "AR6228MT",
  "AR2158WT", "AR2162WT", "AR21665W", "AR2173WT",
]);

const build = (rows, gender, category, garmentType, sfx = "") =>
  rows.map(([code, treatment, graphic]) => ({
    id: id(code, sfx), styleCode: code, gender, category, garmentType,
    treatment, graphic, name: treatment, sub: graphic,
    image: cad(code, sfx), badge: treatment,
    hero: HERO_SET.has(code) && !sfx,
  }));

const buildNewTee = (rows, gender, category, garmentType) =>
  rows.map(([code, treatment, graphic]) => ({
    id: id(code), styleCode: code, gender, category, garmentType,
    treatment, graphic, name: treatment, sub: graphic,
    image: `/refs/new/${code}.jpg`, badge: treatment, hero: false,
  }));

const shirtProducts = MEN_SHIRTS.map((s) => ({
  id: s.file.replace(/_/g, "-"), styleCode: s.code, gender: "Men", category: "men-shirts",
  garmentType: "Button-Down Shirt", treatment: "Button-Down Shirt", graphic: s.desc,
  name: s.name, sub: s.desc, image: `/refs/new/${s.file}.jpg`, badge: s.code, hero: false,
}));

const dressProducts = WOMEN_DRESSES.map(([code, graphic]) => ({
  id: id(code), styleCode: code, gender: "Women", category: "women-dresses",
  garmentType: "T-Shirt Dress", treatment: "T-Shirt Dress", graphic,
  name: "T-Shirt Dress", sub: graphic, image: `/refs/new/${code}.jpg`, badge: null, hero: false,
}));

export const PRODUCTS = [
  ...denimProducts,
  ...build(MEN_TEES, "Men", "men-tees", "T-Shirt"),
  ...buildNewTee(MEN_BASIC_TEES, "Men", "men-basic-tees", "T-Shirt"),
  ...shirtProducts,
  ...build(MEN_FLEECE, "Men", "men-fleece", "Hoodie / Fleece"),
  ...build(WOMEN_TEES, "Women", "women-tees", "T-Shirt"),
  ...dressProducts,
  ...build(WOMEN_FLEECE_1, "Women", "women-fleece", "Sweatshirt / Hoodie"),
  ...build(WOMEN_FLEECE_2, "Women", "women-fleece", "Sweatshirt / Hoodie", "_F"),
  ...build(WOMEN_FLEECE_3, "Women", "women-fleece", "Sweatshirt / Hoodie", "_F"),
];

// --------------------------------------------------------- Collections -------
const tileImg = (cat) => (PRODUCTS.find((p) => p.category === cat) || {}).image;

export const COLLECTIONS = {
  "new-originals": { title: "New Originals", sub: "Signature styles from the line", kind: "hero", eyebrow: "The Line",
    blurb: "The styles that define AR / American Rag — our signature denim fits and hero graphics, straight from the collection." },
  women: { title: "Women", sub: "Denim · Graphic Tees · Dresses · Fleece & Hoodies", kind: "overview", eyebrow: "The Women's Line", subcats: ["women-denim", "women-tees", "women-dresses", "women-fleece"] },
  men: { title: "Men", sub: "Denim · Graphic Tees · Basic Tees · Shirts · Fleece & Hoodies", kind: "overview", eyebrow: "The Men's Line", subcats: ["men-denim", "men-tees", "men-basic-tees", "men-shirts", "men-fleece"] },
  "women-denim": { title: "Women's Denim", sub: "High-Rise Straight & Mid-Rise Boot Cut", kind: "single", eyebrow: "Women · Denim", cat: "women-denim" },
  "men-denim": { title: "Men's Denim", sub: "Slim & Straight · seven washes", kind: "single", eyebrow: "Men · Denim", cat: "men-denim" },
  "women-tees": { title: "Women's Graphic Tees", sub: "Glitter, hot-fix, rhinestone & puff graphics", kind: "single", eyebrow: "Women · Tees", cat: "women-tees" },
  "men-tees": { title: "Men's Graphic Tees", sub: "Embroidery, puff, foil, patch & applique", kind: "single", eyebrow: "Men · Tees", cat: "men-tees" },
  "men-basic-tees": { title: "Men's Basic Tees", sub: "Clean logo, embroidery & patch essentials", kind: "single", eyebrow: "Men · Basic Tees", cat: "men-basic-tees" },
  "men-shirts": { title: "Men's Shirts", sub: "Denim button-downs · five washes", kind: "single", eyebrow: "Men · Shirts", cat: "men-shirts" },
  "women-dresses": { title: "Women's Dresses", sub: "AR / American Rag t-shirt dresses", kind: "single", eyebrow: "Women · Dresses", cat: "women-dresses" },
  "women-fleece": { title: "Women's Fleece & Hoodies", sub: "Rhinestone, sequin, beaded & embellished", kind: "single", eyebrow: "Women · Fleece", cat: "women-fleece" },
  "men-fleece": { title: "Men's Fleece & Hoodies", sub: "Embroidery, chenille, applique & puff", kind: "single", eyebrow: "Men · Fleece", cat: "men-fleece" },
  shop: { title: "The Collection", sub: "Every AR / American Rag style", kind: "all", eyebrow: "Showroom" },
};

export const CATEGORY_LABEL = {
  "women-denim": "Women's Denim", "men-denim": "Men's Denim",
  "women-tees": "Women's Graphic Tees", "men-tees": "Men's Graphic Tees",
  "men-basic-tees": "Men's Basic Tees", "men-shirts": "Men's Shirts",
  "women-dresses": "Women's Dresses",
  "women-fleece": "Women's Fleece & Hoodies", "men-fleece": "Men's Fleece & Hoodies",
};

export const CATEGORY_TILE = {
  "women-denim": tileImg("women-denim"), "men-denim": tileImg("men-denim"),
  "women-tees": tileImg("women-tees"), "men-tees": tileImg("men-tees"),
  "men-basic-tees": tileImg("men-basic-tees"), "men-shirts": tileImg("men-shirts"),
  "women-dresses": tileImg("women-dresses"),
  "women-fleece": tileImg("women-fleece"), "men-fleece": tileImg("men-fleece"),
};

export const byCategory = (cat) => PRODUCTS.filter((p) => p.category === cat);
export const heroStyles = () => PRODUCTS.filter((p) => p.hero);
export const getProduct = (pid) => PRODUCTS.find((p) => p.id === pid);
export const relatedTo = (p) => PRODUCTS.filter((x) => x.category === p.category && x.id !== p.id).slice(0, 4);
